<template>
    <div class="MaterialsChoice mt-0 mb-md-2 mx-0 px-0" @mouseover="changeMatter = true" @mouseleave="changeMatter = false" :class="{'not-allowed': landingpage}">
        <div v-if="allowRotation && selectedThicknessName && !mobile">
            <span class="font-weight-bold mb-1 d-block text-right mx-3 mx-md-0">
                <t v-if="this.cuttingOptions.dxfFormatting == 1" materialsChoice.brushingMetal />
                <t v-else materialsChoice.brushingWood />
                <b-icon class="cursor-pointer" fill="#ffffff" icon="info-circle-fill" font-scale=".9" @click="tutoBrushing = !tutoBrushing" stroke="#ffb400" />
            </span>
            <transition-group name="bounce">
                <div class="fly-over-setting mt-2 mb-3 position-relative" v-if="tutoBrushing" key="tuto" @click="tutoBrushing = null">
                    <div class="bg-white rounded-10 px-3 py-2 text-left d-flex">
                        <img height="25" :src="require('@/assets/img/right-arrow.svg')">
                        <p class="text-dark mb-0 line-height ml-2">
                            <t v-if="this.cuttingOptions.dxfFormatting == 1" materialsChoice.tutoBrushingMetal />
                            <t v-else materialsChoice.tutoBrushingWood />
                        </p>
                    </div>
                </div>
            </transition-group>
        </div>
        <div class="bg-white rounded-10">
            
            <div class="rounded-10 overflow-hidden">
                
                <b-button id="switch-choice" class="w-100 text-left border-0 rounded-top-10 py-2 text-white d-flex align-items-center justify-content-between" variant="link" @click="setSidebarDropped('materials')" :class="{'active': isSidebarDropped == 'materials' || !isSidebarDropped && !pieces.length > 0, 'disabled': landingpage}" v-if="!mobile">
                    <div>
                        <div class="d-flex text-gris align-items-center texture" v-if="selectedThicknessName && isSidebarDropped != 'materials'">
                            <img class="rounded-50 big" :src="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-vignette.jpg'" width="30" height="30">
                            <div class="animated fadeIn d-flex align-items-center" v-if="!changeMatter">
                                <span class="font-weight-bold p-0 ml-2 line-height product_name" :data-matter_name="selectedMatterName" >{{selectedProductName}}</span>
                                <span class="p-0 ml-2 small line-height thickness_name">{{selectedThicknessName}}</span>
                            </div>
                            <span class="p-0 pl-2 animated fadeIn font-weight-bold" v-else><t materialsChoice.changeMaterial /></span>
                        </div>
                        <div class="d-flex text-gris align-items-center" v-else> 
                            <img :src="require( '@/assets/img/material-choice.png')">
                            <span class="p-0 pl-2 font-weight-bold"><t materialsChoice.changeMaterial /></span>
                        </div>
                    </div>
                    <b-icon v-if="!landingpage" icon="arrow-repeat" class="p-1 bg-jaune rounded-50" font-scale="1.4" />
                </b-button>
                <transition name="bounce">
                    <div class="px-2 bg-white border-gris-pro border-5" v-if="isSidebarDropped == 'materials' || !isSidebarDropped && !pieces.length > 0 || mobile" :class="{'choice-made' : !isDroppedChoice}">
                        <div class="pt-2 pt-md-1 pb-2 pb-md-2">
                            <div v-if="allowRotation && selectedThicknessName && mobile">
                                <span class="font-weight-bold mb-1 d-block text-right mx-3 mx-md-0">
                                    <t v-if="this.cuttingOptions.dxfFormatting == 1" materialsChoice.brushingMetal />
                                    <t v-else materialsChoice.brushingWood />
                                    <b-icon class="cursor-pointer" fill="#ffffff" icon="info-circle-fill" font-scale=".9" @click="tutoBrushing = !tutoBrushing" stroke="#ffb400" />
                                </span>
                                <transition-group name="bounce">
                                    <div class="fly-over-setting mt-2 mb-3 position-relative" v-if="tutoBrushing" key="tuto" @click="tutoBrushing = null">
                                        <div class="bg-white rounded-10 px-3 py-2 text-left d-flex">
                                            <img height="25" :src="require('@/assets/img/right-arrow.svg')">
                                            <p class="text-dark mb-0 line-height ml-2">
                                                <t v-if="this.cuttingOptions.dxfFormatting == 1" materialsChoice.tutoBrushingMetal />
                                                <t v-else materialsChoice.tutoBrushingWood />
                                            </p>
                                        </div>
                                    </div>
                                </transition-group>
                            </div>
                            <div id="choix-matiere" class="choix position-relative">
                                <div id="dropdown-matter" class="w-100 p-0 choice overflow-hidden" :class="{'ok' : selectedMatterName}">
                                    <div class="header-dropdown d-flex align-items-center justify-content-between position-relative" :class="{'active' : isDroppedChoice == 'matter'}" @click="dropChoice('matter')">
                                        <div class="d-flex align-items-center">
                                            <svg viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="columns gap" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-columns-gap b-icon bi" style="font-size: 130%;">
                                                <path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"></path>
                                            </svg>
                                            <span class="p-0 pl-2" v-if="selectedMatterName">{{selectedMatterName}}</span>
                                            <span class="p-0 pl-2" v-else><t materialsChoice.matterChoice /></span>
                                        </div>
                                        <b-icon icon="caret-down-fill" font-scale=".8" />
                                    </div>

                                    <transition-group name="bounce" tag="div" v-on:enter="enter">
                                        <div class="content-dropdown position-relative" v-if="isDroppedChoice == 'matter'" key="div">
                                            <div class="py-2 bg-gris-pro rounded-bottom-10">
                                                <div class="d-flex flex-wrap">
                                                    <b-button class="matter-choice pb-1 px-1 pt-2 col-4 texture" v-for="product in metalMatter" :key="product.matter_id" @click="selectedMatter = product;dropChoice('shade');" variant="link" :class="{'active' : selectedMatterName == product.name[language]}">
                                                        <img class="rounded-10 mx-auto d-block shadow-pro" :src="'/modules/johnsteel_editeur/views/img/textures/' + getUrlName(product.name['fr']) + '.jpg'" width="100" height="60">
                                                        <img class="position-absolute" v-if="selectedMatterName == product.name[language]" :src="require('@/assets/img/check.svg')" width="30px">
                                                        <span class="d-block font-weight-bold text-dark rounded-bottom-10 text-center pb-1 px-1 small">{{product.name[language]}}</span>
                                                    </b-button>
                                                </div>

                                                <div class="d-flex flex-wrap">
                                                    <b-button class="matter-choice p-1 pt-2 pb-2 pb-md-0 col-4 texture" v-for="product in woodMatter" :key="product.matter_id" @click="selectedMatter = product;dropChoice('shade')" variant="link" :class="{'active' : selectedMatterName == product.name[language]}">
                                                        <img class="rounded-10 mx-auto d-block shadow-pro" :src="'/modules/johnsteel_editeur/views/img/textures/' + getUrlName(product.name['fr']) + '.jpg'" width="100" height="60">
                                                        <img class="position-absolute" v-if="selectedMatterName == product.name[language]" :src="require('@/assets/img/check.svg')" width="30px">
                                                        <span class="d-block font-weight-bold text-dark rounded-bottom-10 text-center pb-1 px-1 small line-height">{{product.name[language]}}</span>
                                                    </b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </div>
                            </div>

                            <div id="choix-nuance" class="choix mt-2 position-relative">
                                <div id="dropdown-shade" class="w-100 p-0 choice overflow-hidden" :class="{'ok' : selectedProductName}">

                                    <div class="header-dropdown d-flex align-items-center justify-content-between position-relative" :class="{'active' : isDroppedChoice == 'shade'}" @click="dropChoice('shade')">
                                        <div class="d-flex align-items-center">
                                            <svg viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="front" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-front rounded b-icon bi" style="font-size: 130%;">
                                                <path fill-rule="evenodd" d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z"></path>
                                            </svg>
                                            <span class="p-0 pl-2" v-if="selectedProductName">{{selectedProductName}}</span>
                                            <span class="p-0 pl-2" v-else><t materialsChoice.shadeChoice /></span>
                                        </div>
                                        <b-icon icon="caret-down-fill" font-scale=".8" />
                                    </div>

                                    <transition-group name="bounce" tag="div" v-on:enter="enter">
                                        <div class="content-dropdown position-relative" v-if="isDroppedChoice == 'shade'" key="div">
                                            <div class="py-2 bg-gris-pro rounded-bottom-10">
                                                <div class="d-flex flex-wrap pt-1 pt-md-0 align-items-start">
                                                    <b-button @click="selectedProduct = product.psid;dropChoice('thickness')" variant="link" class="shade-choice col-4 px-1 pt-2 pb-1 texture" v-for="product in shadesForProduct" :key="product.message" button-class="p-0" :class="{'active' : selectedProductName == product.name}">
                                                        <div v-if="!product.steelgoods">
                                                            <img class="rounded-10 d-block mx-auto shadow-pro" :src="'/modules/johnsteel_editeur/views/img/textures/' + product.psid + '-vignette.jpg'" width="100" height="60">
                                                            <img class="position-absolute" v-if="selectedProductName == product.name" :src="require('@/assets/img/check.svg')" width="30px">
                                                            <span class="d-block text-dark font-weight-bold rounded-bottom-10 font-we-bold text-center pb-1 px-1 small line-height">{{ product.name[language] }}</span>
                                                        </div>
                                                    </b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </div>
                            </div>
                            <div id="choix-epaisseur" class="choix mt-2 position-relative">
                                <div id="dropdown-thickness" class="w-100 p-0 choice overflow-hidden" :class="{'ok' : selectedThicknessName}">
                                    <div class="header-dropdown d-flex align-items-center justify-content-between position-relative" :class="{'active' : isDroppedChoice == 'thickness'}" @click="dropChoice('thickness')">
                                        <div class="d-flex align-items-center">
                                            <svg viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="border width" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-border-width rounded b-icon bi" style="font-size: 130%;">
                                                <path d="M0 3.5A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-2zm0 5A.5.5 0 0 1 .5 8h15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z"></path>
                                            </svg>
                                            <span class="p-0 pl-2" v-if="selectedThicknessName">{{selectedThicknessName}}</span>
                                            <span class="p-0 pl-2" v-else><t materialsChoice.thicknessChoice /></span>
                                        </div>
                                        <b-icon icon="caret-down-fill" font-scale=".8" />
                                    </div>

                                    <transition-group name="bounce" tag="div" v-on:enter="enter">
                                        <div class="content-dropdown position-relative" v-if="isDroppedChoice == 'thickness'" key="div">
                                            <div class="d-flex flex-wrap pt-2 bg-gris-pro rounded-bottom-10">
                                                <b-button @click="selectedThickness = thickness.psid; dropChoice();setSidebarDropped('materials')" variant="link" class="thickness-choice col-4 p-1 texture" v-for="thickness in thicknessesForProduct" :key="thickness.message" button-class="p-0" :class="{'active' : selectedThicknessName == thickness.name}">

                                                    <div class="img rounded-circle bg-white mx-auto d-flex">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -5 221.26 165" class="mx-2 pt-1" v-if="selectedMatter" :class="selectedMaterialName">
                                                            <defs>
                                                                <pattern id="img1" patternUnits="userSpaceOnUse" width="300" height="200">
                                                                    <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                                </pattern>
                                                            </defs>
                                                            <rect fill="url(#img1)" filter="brightness(50%)" class="cls-1" y="58" width="100%" :height="thickness.thickness"/>
                                                            <path fill="url(#img1)" filter="brightness(60%)" class="cls-1" :d="'M86.17,' + 2 * thickness.thickness + '.85,6.45,' + (50 + Math.round(thickness.thickness)) + '.22a12,12,0,0,0,.14,21.3l80.2,40.28a53.12,53.12,0,0,0,47.67,0l80.2-40.28a12,12,0,0,0,.15-21.3L135.09,'+ 2 * thickness.thickness + '.85a53.09,53.09,0,0,0-48.92,0Z'"/>
                                                            <path fill="url(#img1)" class="cls-2" d="M86.17,6,6.45,47.34a12,12,0,0,0,.14,21.3l80.2,40.28a53.06,53.06,0,0,0,47.67,0l80.2-40.28a12,12,0,0,0,.15-21.3L135.09,6A53.09,53.09,0,0,0,86.17,6Z"/>
                                                        </svg>
                                                        <img class="position-absolute" v-if="selectedThicknessName == thickness.name" :src="require('@/assets/img/check.svg')" width="25px">
                                                    </div>
                                                    <span class="d-block text-dark font-weight-bold rounded-bottom-10 font-we-bold text-center pt-1 pb-0 px-1 small">{{ thickness.name }}</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </transition-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
    import {BIcon, BIconColumnsGap, BIconFront, BIconBorderWidth, BButton, BIconCaretDownFill, BIconBookmark, BIconInfoCircleFill, BIconArrowRepeat} from 'bootstrap-vue'
    import { mapGetters } from 'vuex'
    import { models } from 'feathers-vuex';

    export default {
        components: { BIcon, BIconColumnsGap, BIconFront, BIconBorderWidth, BButton, BIconCaretDownFill, BIconBookmark, BIconInfoCircleFill, BIconArrowRepeat},
        data(){
            return {
                selectedProduct: null,
                selectedThickness: null,
                selectedMatter: null,
                currentStep: null,
                isDroppedChoice: null,
                allowRotation: false,
                products: [],
                thicknesses: [],
                cuttingparams: [],
                tutoBrushing: null,
                landingpage: window.obelix.landingpage,
                language: window.obelix.language,
                changeMatter: false
            }
        },
        async mounted() {
            await this.refreshProducts();
            await this.refreshThicknesses();
            await this.refreshCuttingParams();
            await this.refreshCategories();
            await this.refreshMatters();

            this.dataLoaded = false;
            this.selectedProduct = this.$store.getters.productPsid;
            this.selectedThickness = this.$store.getters.thicknessPsid;
            this.$store.dispatch('setMaterialName', this.materialInitialized);
            this.$store.dispatch('setMatterName', this.matterInitialized);
            this.selectedMatter = this.$store.getters.matterName;
            this.$nextTick(() => {
                this.dataLoaded = true
            });
        },
        computed: {
            ...mapGetters([
                'pieces',
                'isSidebarDropped',
                'cuttingOptions',
                'mobile'
            ]),

            matterInitialized: function() {
                if (this.selectedProduct == null) return "";
                let matter = this.products.find(p => p.psid == this.selectedProduct);
                if (matter == null) return "";
                return matter;
            },
            materialInitialized: function() {
                if (this.selectedProduct == null) return "";
                let matter = this.products.find(p => p.psid == this.selectedProduct);
                if (matter == null) return "";
                return this.$store.dispatch('setMaterialName', this.getCategoryName(matter.matter_id));
            },

            thicknessesForProduct: function() {
                let thicknessIds = this.cuttingparams
                    .filter(p => p.product == this.selectedProduct && p.cuttingOptions.active == 1)
                    .map(p => p.thickness);

                return this.thicknesses.filter(t => thicknessIds.includes(t.psid) );
            },
            shadesForProduct() {
                return this.products.filter(product => {
                    return product.matter_id == this.selectedMatter.matter_id && !product.steelgoods;
                });
            },
            selectedProductName: function() {
                if (this.$store.getters.productPsid == null) return "";
                let product = this.products.find(p => p.psid == this.$store.getters.productPsid);
                if (product == null) return "";
                this.allowRotation = (this.cuttingOptions.allowMaterialRotation == 0)
                return product.name[this.language];
            },
            selectedThicknessName: function() {
                if (this.$store.getters.thicknessPsid == null) {
                    // this.showMaterialsChoice = true;
                    return "";
                } else {
                    // this.showMaterialsChoice = false;
                }
                let thickness = this.thicknesses.find(p => p.psid == this.$store.getters.thicknessPsid);
                if (thickness == null) return "";
                return thickness.name;
            },
            selectedMaterialName: function() {
                return this.$store.getters.materialName;
            },
            selectedMatterName: function() {
                return this.$store.getters.matterName;
            },
            selectedProductImageUrl: function() {
                return this.$store.getters.productImg;
            },
            metalMatter(){
                return this.matters.filter(matter => {
                    return matter.category_id == 1;
                });
            },
            woodMatter(){
                return this.matters.filter(matter => {
                    return matter.category_id == 2;
                });
            },
            mobile: function() {
                return this.$store.getters.mobile;
            },
            uniquePieces: function() {
                return this.pieces ? this.pieces.filter(p => !p.isCopyOf) : []
            }
        },
        methods: {
            async refreshProducts() {
                let blockSize = 20;
                let response = await models.api.Product.find({query: {$limit: blockSize}});
                this.products = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Product.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.products = this.products.concat(response.data);
                }
                this.products.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            },
            async refreshThicknesses() {
                let blockSize = 50;
                let response = await models.api.Thickness.find({query: {$limit: blockSize}});
                this.thicknesses = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Thickness.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.thicknesses = this.thicknesses.concat(response.data);
                }
                this.thicknesses.sort((a, b) => a.thickness - b.thickness);
                this.thicknesses.forEach(t => t.name = t.thickness + ' mm');
            },

            async refreshCuttingParams() {
                let blockSize = 20;
                let response = await models.api.CuttingParams.find({query: {$limit: blockSize}});
                this.cuttingparams = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.CuttingParams.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.cuttingparams = this.cuttingparams.concat(response.data);
                }

                let activeProducts = new Set(this.cuttingparams
                    .filter(cp => cp.cuttingOptions.active == 1)
                    .map(cp => cp.product));

                this.products = this.products.filter(p => activeProducts.has(p.psid));
            },

            async refreshCategories() {
                let blockSize = 20;
                let response = await models.api.Category.find({query: {$limit: blockSize}});
                this.categories = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Category.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.categories = this.categories.concat(response.data);
                }
                this.categories.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            },

            async refreshMatters() {
                let blockSize = 20;
                let response = await models.api.Matter.find({query: {$limit: blockSize}});
                this.matters = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Matter.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.matters = this.matters.concat(response.data);
                }
                this.matters.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            },
            hideModal() {
                this.$refs['modal-1'].hide();
            },
            dropChoice(element) {
                if (element == 'matter') {
                    this.isDroppedChoice = 'matter';
                } else if (element == 'shade') {
                    this.isDroppedChoice = 'shade';
                } else if (element == 'thickness') {
                    this.isDroppedChoice = 'thickness';
                } else if (element == null) {
                    this.isDroppedChoice = null;
                    this.$store.dispatch('setDropped', null);
                }
            },
            getUrlName(name) {
                var accent = [
                    /[\300-\306]/g, /[\340-\346]/g, // A, a
                    /[\310-\313]/g, /[\350-\353]/g, // E, e
                    /[\314-\317]/g, /[\354-\357]/g, // I, i
                    /[\322-\330]/g, /[\362-\370]/g, // O, o
                    /[\331-\334]/g, /[\371-\374]/g, // U, u
                    /[\321]/g, /[\361]/g, // N, n
                    /[\307]/g, /[\347]/g, // C, c
                ];
                var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

                for(var i = 0; i < accent.length; i++){
                    name = name.replace(accent[i], noaccent[i]);
                }
                return name.replace(' ', '-').toLowerCase();
            },
            setSidebarDropped(element) {
                if (this.isSidebarDropped != element) {
                    this.$store.dispatch('setIsSidebarDropped', element);
                } else {
                    this.$store.dispatch('setIsSidebarDropped', 'addtocart');
                }
            },
            getMaterialTrad(name, toLanguage, fromLanguage){
                if(name){
                    return this.products.find(product => {
                        return product.category[fromLanguage].split(':')[0] == name;
                    }).category[toLanguage].split(':')[0];
                }              
                else{
                    return name;
                }
            },
            enter: function (el, done) {
                done();
                setTimeout(function() {
                    document.querySelector('.animation').style.height = el.offsetHeight + 148 + 'px';
                }, 130);
            },
            getCategoryName(matter_id){
                if(this.matters.find(t => t.matter_id == matter_id)){
                    let matter = this.matters.find(t => t.matter_id == matter_id);
                    if(typeof(this.categories[0]) != "undefined"){
                        return this.categories.find(t => t.category_id == matter.category_id).name['fr'];
                    }
                }
            },
        },
        watch: {
            selectedProduct: async function() {
                if (this.thicknessesForProduct.length < 1) return;
                if (this.thicknessesForProduct.some(t => t.psid == this.selectedThickness)) {
                    if (this.dataLoaded) this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
                }
                if (this.dataLoaded) {
                    if (this.dataLoaded) this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
                    this.selectedThickness = null;
                }

                let product = this.products.find(p => p.psid == this.$store.getters.productPsid);
                this.$store.dispatch('setProductImg', product.img);
            },
            selectedThickness: async function() {
                if (this.dataLoaded) this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
            },
            selectedMatter: async function() {
                if(this.selectedMatter){
                    this.$store.dispatch('setMaterialName', this.getCategoryName(this.selectedMatter.matter_id));
                    this.$store.dispatch('setMatterName', this.selectedMatter.name[this.language]);
                }
                if (this.dataLoaded) {
                    this.selectedProduct = null;
                    this.selectedThickness = null;
                }
            }
        },
    }
</script>

<style lang="scss">
    @import './../../assets/scss/_variables.scss';

    ::-webkit-scrollbar {
        display: none;
    }

    #switch-choice {
        position: relative;
        z-index: 10;
        background: #fff;
        border-radius: 10px!important;
        transition: all .3s ease-in-out;

        &.active {
            border-radius: 10px 10px 0 0!important;
        }

        img {
            height: 30px;

            &.big {
                height: 30px;
            }
        }

        .animated {
            animation-duration: 1.5s!important;
        }
    }

    #MaterialsChoice {
        .bg-white.border-gris-pro {
            border: 0!important;

            @media (max-width: 768px) {
                border-width: 5px!important;
            }
        }
    }

    .btn:focus {
        box-shadow: none!important;
    }

    .MaterialsChoice {
        @media (max-width: 768px) {
            border-radius: 0;
            width: auto;
        }

        .content-rounded {
            @media (max-width: 768px) {
                background: $white;
            }
        }

        .bi-info-circle-fill {
            stroke: $white!important;
            fill: $jaune!important;
        }

        .fly-over-setting {
            img {
                height: 32px;
            }

            &:after {
                right: 50px;
                left: auto;
                border-bottom: 15px solid #fff;
            }
        }

        .bi-arrow-repeat {
            transition: all .3s ease-in-out;
        }

        &:hover {
            .bi-arrow-repeat {
                transform: rotate(180deg) scale(1.25);
            }
        }
    }

    .rounded-50 {
        border-radius: 50%;
    }

    .btn-grey {
        background-color: $gris-btn!important;
        color: $white;
        font-weight: bold;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .choice {
        transition: all .5s ease-in-out;
    }

    .header-dropdown {
        background: #a39797a6;
        padding: .375rem .75rem;
        border-radius: 10px;
        cursor: pointer;
        max-height: 700px;
        transition: all .3s ease-in-out;
        z-index: 1;
        opacity: .5;

        &.active {
            border-radius: 10px 10px 0 0;
            opacity: 1;
        }

        @media (max-width: 768px) {
            background: #f3f3f3;
            color: #6c757d;
        }
    }

    .content-dropdown {
        animation-delay: 0s;
        transform-origin: top;
        background: $grispro;
        border-radius: 0 0 10px 10px;
        transition: all .5s ease-in-out;
        animation-delay: 0s;
    }
    .choice-made {
        .header-dropdown {
            opacity: 1!important;
        }
    }
    .matter-choice,
    .shade-choice {
        &.active {
            img.shadow-pro {
                box-shadow: 0 0 0 4px $grispro, 0 0 0 6px $gris;
            }
            img.position-absolute {
                top: 18px;
                left: 0;
                right: 0;
                display: block;
                margin: auto;
            }
        }
    }
    .thickness-choice {
        &.active {
            .img {
                box-shadow: 0 0 0 4px $grispro, 0 0 0 6px $gris;
            }
            img {
                top: 18px;
                left: 0;
                right: 0;
                display: block;
                margin: auto;

                @media (max-width: 576px) {
                    width: 35px;
                    top: 15px;
                }
            }
        }
    }
    #choix-epaisseur {
        .img {
            width: 60px;
            height: 55px;

            @media (max-width: 576px) {
                width: 65px;
                height: 60px;
            }

            svg {
                height: 58px;

                @media (max-width: 576px) {
                    height: 60px;
                }
            }
        }
    }
    #dropdown-shade {
        button span {
            white-space: initial;
        }
    }
    .bi-caret-down-fill {
        transition: all .3s ease-in-out;
    }
    .active {
        .bi-caret-down-fill {
            transform: rotate(180deg);
        }
    }
    .not-allowed{
        pointer-events: visible;
        cursor: not-allowed;
    }
</style>
